import {
    Paper,
    List,
    ListItem,
    ListItemText,
    Typography,
    Button,
    CircularProgress,
    Switch,
    ListItemSecondaryAction,
    IconButton,
} from '@mui/material';
import { InfoListItem } from '@brightlayer-ui/react-components';
import React, { useEffect } from 'react';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import MailIcon from '@mui/icons-material/Mail';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PushNotificationSolidIcon from '@brightlayer-ui/icons-mui/PushNotificationSolid';
import LockIcon from '@mui/icons-material/Lock';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { useDispatch, useSelector } from 'react-redux';
// import {  useAuthState } from '../AuthContextProvider';
import { Actions } from '../../actions';
import EditIcon from '@mui/icons-material/Edit';
import { UserState } from '../../state/user-state';
import { useToasts } from '../../data/DataProviders/ToastProvider';
import { UserBasicInfo, UserInfo } from '../../types';
import { EditUserDetails } from '../EditUserDetails/EditUserDetails';
import { Selectors } from '../../selectors';
import * as PXBColors from '@brightlayer-ui/colors';

export const UserDetails: React.FC<{
    userId: string;
    userData: UserInfo;
    userState: UserState;
    userInfo?: any;
    onSubmit: Function;
    userUpdateLoading: boolean;
    openPassword?: Function;
    onResetPassword?: Function;
    openSMSModal: Function;
    openDisclaimer: Function;
    disableAutomaticLogout: Function;
    hasDirty: Function;
    confirmDiscard: boolean;
    loggedinUser: boolean;
    loggedUser: boolean;
    handleEmail: Function;
    handleSms: Function;
    emailStatus: boolean;
    smsStatus: boolean;
    automaticLogOut: boolean;
    edit: boolean;
    updateEdit: Function;
    handleCancelClick?: Function;
    showUserDetailsEdit?: boolean;
}> = (props) => {
    const { t } = useLanguageLocale();
   // const authState = useAuthState();
    const dispatch = useDispatch();

    const user = props.userData;
    

    // const userId = getUserId(authState);
    // const authHelper = useAuthHelper();
    const { addToast } = useToasts();
    const forgetPasswordLoading = useSelector(Selectors.Authentication.forgotPasswordLoading);
    const forgetPasswordSuccess = useSelector(Selectors.Authentication.forgotPasswordSuccess);
    const forgetPasswordErrorMessage = useSelector(Selectors.Authentication.forgotPasswordErrorMessage);

    const userInfo = props.loggedinUser ? props.userState : props.userInfo;

    const showEdit = props.loggedinUser ? !props.edit : props.showUserDetailsEdit;

    const phone =  (`${user.user.countryCode || ''}${user.user.phone || ''}`);
    
   

    //eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (props.confirmDiscard) props.updateEdit(false);
    }, [props.confirmDiscard]);

    useEffect(() => {
        if (!forgetPasswordLoading && forgetPasswordSuccess) {
            addToast(t('USERDETAILS.RESET_PASSWORD_SUCCESS'));
            dispatch(Actions.Authentication.resetPasswordReset());
        } else if (forgetPasswordErrorMessage !== '') {
            addToast(t('USERDETAILS.RESET_PASSWORD_ERROR'));
            dispatch(Actions.Authentication.resetPasswordReset());
        }
    }, [forgetPasswordLoading, forgetPasswordSuccess]);

    const onSumbit = (UserBasicDetails: UserBasicInfo): void => {
        if(props.loggedinUser){
            props.onSubmit(
                UserBasicDetails.fName,
                UserBasicDetails.lName,
               // UserBasicDetails.email,
                UserBasicDetails.phone,
                UserBasicDetails.countryCode
            );
        }
        else{
            props.onSubmit(
                UserBasicDetails.fName,
                UserBasicDetails.lName,
                UserBasicDetails.email,
                UserBasicDetails.phone,
                UserBasicDetails.countryCode
            );
        }
     
    };

    const onCancel = (): void => {
        if(props.loggedinUser){
            props.updateEdit(false);
            props.hasDirty(false);
        }
        else {
            if(props.handleCancelClick)
            props.handleCancelClick();
        }
      
    };
    const setDirty = (value: boolean): void => {
        props.hasDirty(value);
    };
    return (
        <>
            <Paper style={{ marginTop: 40 }} >
                
                <List
                    component="div"
                    disablePadding
                    subheader={
                        <ListItem divider={true} style={{ backgroundColor: 'transparent' }}>
                            <ListItemText
                                primary={
                                    <Typography variant="h6" color="primary">
                                        User Details
                                    </Typography>
                                }
                            ></ListItemText>
                            <ListItemSecondaryAction>
                                {showEdit && props.loggedUser &&(
                                    <IconButton
                                        edge="end"
                                        aria-label="edit"
                                        onClick={(): void => {
                                            props.updateEdit(true);
                                        }}
                                        //disabled={props.loggedinUser ? false : true}
                                
                                    >
                                        <EditIcon  />
                                    </IconButton>
                                )}
                            </ListItemSecondaryAction>
                        </ListItem>
                    }
                >
                    {!props.edit && (
                        <>
                            <InfoListItem
                                divider={'full'}
                                data-testid="user-name"
                                icon={<AccountCircleIcon/>}
                                title={`${user.user.fName} ${user.user.lName}`}
                                subtitle={t('USER_SETTINGS.NAME')}
                            ></InfoListItem>

                            <InfoListItem
                                divider={'full'}
                                data-testid="user-email"
                                icon={<MailIcon />}
                                title={user.user.email}
                                subtitle={t('USER_SETTINGS.EMAIL')}
                            ></InfoListItem>

                            <InfoListItem
                                divider={'full'}
                                data-testid="phone-number"
                                icon={<LocalPhoneIcon />}
                                title={phone}
                                subtitle={t('USER_SETTINGS.PHONE_NUMBER')}
                                rightComponent={
                                    <Typography variant="subtitle2">{t('USER_SETTINGS.PHONE_NO_TEXT')}</Typography>
                                }
                            ></InfoListItem>

                            <InfoListItem
                                divider={'full'}
                                data-testid="password"
                                icon={<LockIcon />}
                                title={'*********'}
                                subtitle={t('USER_SETTINGS.PASSWORD')}
                                rightComponent={
                                    props.loggedinUser  ? 
                                    <Button
                                        id="btnChangePassword"
                                        data-testid="change-password"
                                        variant="outlined"
                                        color="primary"
                                        onClick={(): void => {
                                            if(props.openPassword)
                                            props.openPassword(true)
                                        }}
                                       >
                                        {t('USER_SETTINGS.CHANGE_PASSWORD')}
                                    </Button> :
                                    props.loggedUser?
                                    <>
                                    {forgetPasswordLoading && !forgetPasswordSuccess && (
                                        <Button
                                            variant="contained"
                                            disabled
                                            startIcon={
                                                <CircularProgress
                                                    size="1rem"
                                                    style={{ color: 'white' }}
                                                />
                                            }
                                            style={{
                                                height: '40px',
                                                marginRight: 15,
                                                backgroundColor: PXBColors.blue[200],
                                                color: 'white',
                                            }}
                                        >
                                            Reset Password
                                        </Button>
                                    )}
                                    {!forgetPasswordLoading && (
                                        <Button
                                            id="btnChangePassword"
                                            data-testid="change-password"
                                            variant="outlined"
                                            color="primary"
                                            onClick={(): void => {
                                                if(props.onResetPassword)
                                                props.onResetPassword(user.user.email.toString());
                                            }}
                                        >
                                            Reset Password
                                        </Button>
                                    )}
                                </>
                                : ''
                                }
                            ></InfoListItem>

                          
                        </>
                    )}
                    {props.edit && (
                        <EditUserDetails
                            userInfo={userInfo}
                            userDetailsInfo={user}
                            onSubmit={onSumbit}
                            onCancel={onCancel}
                            isDirty={setDirty}
                        ></EditUserDetails>
                    )}
                </List>
            </Paper>
            <Paper style={{ marginTop: 40 }}> 
            <List
                    component="div"
                    disablePadding
                    subheader={
                        <ListItem divider={true} style={{ backgroundColor: 'transparent' }}>
                            <ListItemText
                                primary={
                                    <Typography variant="h6" color="primary">
                                        User Preferences
                                    </Typography>
                                }
                            ></ListItemText>
                        </ListItem>
                    }
                >
                  <InfoListItem
                                divider={'full'}
                                data-testid="notification-status"
                                icon={<NotificationsIcon />}
                                title={t('USER_SETTINGS.EMAIL_NOTIFICATION')}
                                subtitle={props.emailStatus ? 'Enabled' : 'Disabled'}
                                rightComponent={
                                    <>
                                        {userInfo.emailLoading && <CircularProgress size="2rem" />}
                                        {!userInfo.emailLoading &&  props.loggedUser &&(
                                            <Switch
                                                id="enableNotification"
                                                data-testid="enableNotification"
                                                checked={props.emailStatus}
                                                onChange={(e): void => {
                                                    props.handleEmail(e.target.checked);
                                                }}
                                                color="primary"
                                              
                                            />
                                        )}
                                    </>
                                }
                            ></InfoListItem>
                            <InfoListItem
                                divider={'full'}
                                data-testid="notification-sms"
                                icon={<PushNotificationSolidIcon />}
                                title={t('USER_SETTINGS.TEXT_NOTIFICATION')}
                                subtitle={props.smsStatus ? 'Enabled' : 'Disabled'}
                                rightComponent={
                                    <>
                                        {userInfo.smsLoading && <CircularProgress size="2rem" />}
                                        {!userInfo.smsLoading && props.loggedUser &&(
                                            <Switch
                                                id="enableTextNotification"
                                                data-testid="enableSmsNotification"
                                                //disabled={userInfo.smsLoading}
                                                checked={props.smsStatus}
                                                onChange={(e): void => {
                                                    if (e.target.checked) props.openSMSModal(true);
                                                    else props.handleSms(e.target.checked);
                                                }}
                                                color="primary"
                                                
                                            />
                                        )}
                                    </>
                                }
                            ></InfoListItem>
                            <InfoListItem
                                divider={'full'}
                                data-testid="automatic-logout"
                                icon={<LockIcon />}
                                title={t('USER_SETTINGS.AUTOMATIC_LOGOUT')}
                                subtitle={props.automaticLogOut ? 'Enabled (Recommended)' : 'Disabled'}
                                rightComponent={
                                    <>
                                        {userInfo.sessionLoading && <CircularProgress size="2rem" />}
                                        {!userInfo.sessionLoading && props.loggedUser &&(
                                            <Switch
                                                id="automaticLogOut"
                                                data-testid="automatic-logout-toggle"
                                                checked={props.automaticLogOut}
                                                onChange={(e): void => {
                                                    if (!e.target.checked) props.openDisclaimer(true);
                                                    else props.disableAutomaticLogout(e.target.checked);
                                                }}
                                                color="primary"
                                               
                                            />
                                        )}
                                    </>
                                }
                            ></InfoListItem>

                </List>

            </Paper>
        </>
    );
};
